import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  AuditExportFormat,
  AuditLogQuery,
  AuditLogResponse,
} from "./audit-log.interface";

@Injectable({ providedIn: "root" })
export class AuditLogService {
  constructor(private readonly http: HttpClient) {}

  getLogs(query: AuditLogQuery): Observable<AuditLogResponse> {
    let params = new HttpParams()
      .set("page", query.page.toString())
      .set("limit", query.limit.toString());

    if (query.email) params = params.set("email", query.email);
    if (query.actionType) params = params.set("actionType", query.actionType);
    if (query.entityType) params = params.set("entityType", query.entityType);
    if (query.entityName) params = params.set("entityName", query.entityName);
    if (query.summary) params = params.set("summary", query.summary);
    if (query.search) params = params.set("search", query.search);
    if (query.dateFrom) params = params.set("dateFrom", query.dateFrom);
    if (query.dateTo) params = params.set("dateTo", query.dateTo);
    if (query.sortBy) params = params.set("sortBy", query.sortBy);
    if (query.order) params = params.set("order", query.order);

    return this.http.get<AuditLogResponse>("/audit-log", { params });
  }

  exportLogs(
    query: AuditLogQuery,
    format: AuditExportFormat,
  ): Observable<Blob> {
    let params = new HttpParams().set("format", format);
    if (query.email) params = params.set("email", query.email);
    if (query.actionType) params = params.set("actionType", query.actionType);
    if (query.entityType) params = params.set("entityType", query.entityType);
    if (query.entityName) params = params.set("entityName", query.entityName);
    if (query.summary) params = params.set("summary", query.summary);
    if (query.search) params = params.set("search", query.search);
    if (query.dateFrom) params = params.set("dateFrom", query.dateFrom);
    if (query.dateTo) params = params.set("dateTo", query.dateTo);
    if (query.sortBy) params = params.set("sortBy", query.sortBy);
    if (query.order) params = params.set("order", query.order);

    return this.http.get("/audit-log/export", {
      params,
      responseType: "blob",
    });
  }
}
